export default {
    state: {
        details: [],
        detail_id: null,
        errors: {},
        url: '/api/hms/inspections/details',
        meta: {
            current_page: 1,
            per_page: 10,
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'description', label: 'Description'},
                {key: 'category', label: 'Category', tdClass: 'text-muted'},
                {key: 'concern', label: 'Concern', stdClass: 'text-muted'},
                {key: 'weightage', label: 'Weight', thClass: 'text-center', tdClass: 'text-center'},
                {key: 'status', label: 'Status', thClass: 'text-center', tdClass: 'text-center'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
        form: {
            category_id: '',
            concern_id: '',
            weightage: '',
            description: '',
        },
    },

    getters: {
        getInspectionDetailsMeta: state => state.meta,

        getInspectionDetailTableFields: state => state.table.fields,

        getInspectionDetailErrors: state => state.errors,

        getInspectionDetailForm: state => state.form,
    },

    mutations: {
        resetInspectionDetailsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setInspectionDetails: (state, payload) => {
            state.details = payload;
        },

        setInspectionDetailsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setInspectionDetailErrors: (state, payload) => {
            state.errors = payload;
        },

        setInspectionDetailForm: state => {
            state.form = {
                category_id: '',
                concern_id: '',
                weightage: '',
                description: '',
            };

            state.errors = {};
        },
    },

    actions: {
        fetchInspectionDetails: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };

            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url+'?state', {params: parameters})
                    .then(response => {
                        commit('setInspectionDetails', response.data);

                        commit('setInspectionDetailsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('setInspectionDetailErrors', error.response.data.errors);

                        reject();
                    });
            });
        },

        fetchInspectionEditDetail: ({state, commit}, detail_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + detail_id + '/edit')
                    .then(response => {
                        state.detail_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitInspectionDetail: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setInspectionDetailErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateInspectionDetail: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.detail_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setInspectionDetailErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteInspectionDetail: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.detail_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
    }
}
